<template>
  <div>
    <div
      v-for="(register, index) in list"
      :key="index"
      class="bg-white p-4 rounded my-2"
    >
      <div class="row">
        <div v-if="register.info.nome" class="col-md-3 col-lg-4">
          <div class="label text-capitalize">
            {{ register.info.nome.label }}
          </div>
          <div class="value text-truncate">{{ register.info.nome.value }}</div>
        </div>
        <div v-if="register.info.plano" class="col-md-5 col-lg-4 mt-3 mt-md-0">
          <div class="label">{{ register.info.plano.label }}</div>
          <div class="value font-weight-normal">
            {{ register.info.plano.value }}
          </div>
        </div>
        <div
          v-if="register.info.preco"
          class="col-md-2 col-lg-2 mt-3 mt-md-0 text-md-right d-flex flex-column justify-content-center"
        >
          <div class="value text-primary">
            {{ register.info.preco.value | currency }}
          </div>
          <div class="label">{{ register.info.preco.label }}</div>
        </div>
        <div
          class="col-md-2 col-lg-2 mt-3 mt-md-0 justify-content-md-end align-items-center d-flex"
        >
          <button
            v-for="(data, k) in register.actions"
            :key="k"
            class="btn btn-link border ml-0 mr-2 mr-md-0 ml-md-2"
            :disabled="data.disabled"
            :class="{ disabled: data.disabled }"
            v-on:click="acao(data.action, data.id)"
          >
            <i v-if="data.icon" class="material-icons">{{ data.icon }}</i>
            <span v-else>{{ data.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TituloPaginas",
  props: {
    plan: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  methods: {
    acao(action, id) {
      this.$emit(action, id);
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
